import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function VerifyEmail({ email }) {
    const navigate = useNavigate();

    return (
        <div className="auth-container">
            <div className="auth-header">
                <h1 className="game-title">
                    <span className="zero">ZERO</span>
                    <span className="ping">PING</span>
                </h1>
                <p className="tagline">Battle Royale Tournament Platform</p>
            </div>

            <div className="card" style={{ maxWidth: '500px', textAlign: 'center' }}>
                <div style={{ fontSize: '4rem', marginBottom: '20px' }}>📧</div>
                <h2 style={{
                    fontSize: '2rem',
                    marginBottom: '20px',
                    color: 'var(--primary-color)',
                    fontFamily: 'Orbitron, sans-serif'
                }}>
                    Verify Your Email
                </h2>

                <p style={{
                    fontSize: '1.1rem',
                    color: 'var(--text-secondary)',
                    lineHeight: '1.6',
                    marginBottom: '30px'
                }}>
                    We've sent a verification link to your email address.
                    <br />
                    Please check your inbox (and spam folder) to activate your account.
                </p>

                <div style={{
                    background: 'rgba(0, 240, 255, 0.1)',
                    padding: '20px',
                    borderRadius: '8px',
                    border: '1px solid var(--primary-color)',
                    marginBottom: '30px'
                }}>
                    <p style={{ margin: 0, fontWeight: 'bold', color: 'var(--text-primary)' }}>
                        After verifying, come back here to login!
                    </p>
                </div>

                <button
                    className="btn btn-primary"
                    onClick={() => navigate('/login')}
                    style={{ width: '100%' }}
                >
                    Go to Login
                </button>

                <p style={{ marginTop: '20px', fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
                    Didn't receive the email? <button
                        className="btn-link"
                        style={{ color: 'var(--secondary-color)', textDecoration: 'underline', cursor: 'pointer', background: 'none', border: 'none', padding: 0 }}
                        onClick={() => toast.info('Please try registering again or contact support.')}
                    >
                        Resend
                    </button>
                </p>
            </div>
        </div>
    );
}

export default VerifyEmail;
